/**
 * @description:
 * This file is used for legacy styling please use the SC theme (./theme.ts), this file should not be added to.
 *
 * @notes
 * The derpy as fuck `mainTheme?.colors.blah || "#00ADEE" is for the unit-tests.
 * There is a horrid circular reference going on which is caused by not fully deprecating this file.
 * Normal running of the website should be totally un-affected.
 */
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6;
import mainTheme from "./theme";
var callToAction = {
    default: ((_a = mainTheme) === null || _a === void 0 ? void 0 : _a.colors.callToAction.default) || "#00ADEE",
    hover: ((_b = mainTheme) === null || _b === void 0 ? void 0 : _b.colors.callToAction.hover) || "#00ADEE",
    pressed: ((_c = mainTheme) === null || _c === void 0 ? void 0 : _c.colors.callToAction.pressed) || "#00ADEE"
};
var success = ((_d = mainTheme) === null || _d === void 0 ? void 0 : _d.colors.success) || "#00ADEE";
var error = ((_e = mainTheme) === null || _e === void 0 ? void 0 : _e.colors.error) || "#00ADEE";
var fontColor = ((_f = mainTheme) === null || _f === void 0 ? void 0 : _f.colors.fontColor) || "#00ADEE";
var tooltip = ((_g = mainTheme) === null || _g === void 0 ? void 0 : _g.colors.tooltip) || "#00ADEE";
var warning = {
    default: callToAction.default
};
var greys = {
    white: ((_h = mainTheme) === null || _h === void 0 ? void 0 : _h.colors.greys.white) || "#00ADEE",
    lightest: ((_j = mainTheme) === null || _j === void 0 ? void 0 : _j.colors.greys.lightest) || "#00ADEE",
    graphGrey: ((_k = mainTheme) === null || _k === void 0 ? void 0 : _k.colors.greys.graphGrey) || "#00ADEE",
    light: ((_l = mainTheme) === null || _l === void 0 ? void 0 : _l.colors.greys.light) || "#00ADEE",
    mediumLight: ((_m = mainTheme) === null || _m === void 0 ? void 0 : _m.colors.greys.mediumLight) || "#00ADEE",
    medium: ((_o = mainTheme) === null || _o === void 0 ? void 0 : _o.colors.greys.medium) || "#00ADEE",
    mediumDark: ((_p = mainTheme) === null || _p === void 0 ? void 0 : _p.colors.greys.mediumDark) || "#00ADEE",
    dark: ((_q = mainTheme) === null || _q === void 0 ? void 0 : _q.colors.greys.dark) || "#00ADEE",
    black: ((_r = mainTheme) === null || _r === void 0 ? void 0 : _r.colors.greys.black) || "#00ADEE",
    disabledText: ((_s = mainTheme) === null || _s === void 0 ? void 0 : _s.colors.greys.disabledText) || "#00ADEE",
    disabled: ((_t = mainTheme) === null || _t === void 0 ? void 0 : _t.colors.greys.disabled) || "#00ADEE"
};
var borderGreyPrimary = ((_u = mainTheme) === null || _u === void 0 ? void 0 : _u.colors.border.greyPrimary) || "#00ADEE";
var borderGreySecondary = ((_v = mainTheme) === null || _v === void 0 ? void 0 : _v.colors.border.greySecondary) || "#00ADEE";
var dropShadowGrey = ((_w = mainTheme) === null || _w === void 0 ? void 0 : _w.colors.greys.dropShadowGrey) || "#00ADEE";
var perkbox = {
    blue: ((_x = mainTheme) === null || _x === void 0 ? void 0 : _x.colors.perkbox.blue) || "#00ADEE",
    darkBlue: ((_y = mainTheme) === null || _y === void 0 ? void 0 : _y.colors.perkbox.darkBlue) || "#00ADEE",
    greenBlue: ((_z = mainTheme) === null || _z === void 0 ? void 0 : _z.colors.perkbox.greenBlue) || "#00ADEE"
};
var brand = {
    default: ((_0 = mainTheme) === null || _0 === void 0 ? void 0 : _0.colors.brand.default) || "#00ADEE",
    shade: ((_1 = mainTheme) === null || _1 === void 0 ? void 0 : _1.colors.brand.shade) || "#00ADEE",
    dark: ((_2 = mainTheme) === null || _2 === void 0 ? void 0 : _2.colors.brand.dark) || "#00ADEE",
    hover: ((_3 = mainTheme) === null || _3 === void 0 ? void 0 : _3.colors.brand.hover) || "#00ADEE"
};
// legacy function to update the brand object in this file, should be removed once we use the theme everywhere
export function updateLegacyBrand(themeBrand) {
    Object.keys(themeBrand).forEach(function (key) {
        brand[key] = themeBrand[key];
    });
}
var productColors = {
    insights: ((_4 = mainTheme) === null || _4 === void 0 ? void 0 : _4.colors.products.insights) || "#00ADEE",
    medical: ((_5 = mainTheme) === null || _5 === void 0 ? void 0 : _5.colors.products.medical) || "#00ADEE",
    perks: perkbox.blue,
    recognition: ((_6 = mainTheme) === null || _6 === void 0 ? void 0 : _6.colors.products.recognition) || "#00ADEE"
};
export { perkbox, fontColor, success, warning, callToAction, greys, error, brand, borderGreyPrimary, borderGreySecondary, dropShadowGrey, tooltip, productColors };
